const locationBt = {
	selector: {
		districtLabel: 'ལྷོད་ཁུལ་',
		upazillaLabel: 'ཡུལ་ཚོམ་',
		bazarLabel: 'ཚོང་ཟོར་',
		districtSearchPlaceholder: 'ལྷོད་ཁུལ་འཚོལ་བསྡུར...',
		upazillaSearchPlaceholder: 'ཡུལ་ཚོམ་འཚོལ་བསྡུར...',
		bazarSearchPlaceholder: 'ཚོང་ཟོར་འཚོལ་བསྡུར...'
	},
	popup: {
		title: 'ཁྱེད་ཀྱི་ཁུལ་སྤྱོད་ས་གདམ།',
		instruction: 'གྲགས་མང་སྤྱོད་ལམ་ཚུལ་ལེགས་བཟོ་བྱེད་ནི་ལུ་ ལྷོད་ཁུལ་ ཡུལ་ཚོམ་ ཚོང་ཟོར་གདམ།',
		chooseDistrict: 'ལྷོད་ཁུལ་གདམ།',
		chooseUpazilla: 'ཡུལ་ཚོམ་གདམ།',
		chooseBazar: 'ཚོང་ཟོར་གདམ།',
		districtSearchPlaceholder: 'ལྷོད་ཁུལ་འཚོལ་བསྡུར...',
		upazillaSearchPlaceholder: 'ཡུལ་ཚོམ་འཚོལ་བསྡུར...',
		bazarSearchPlaceholder: 'ཚོང་ཟོར་འཚོལ་བསྡུར...',
		selectedPrefix: 'སེལ་འཐུ་:',
		confirm: 'ངེས་ཐག་བཟོ།'
	}
};

export default locationBt;


